import React from 'react'
import { graphql } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'

// Components
import Layout from '../components/layout'
import SearchForm from '../components/searchForm'
import Seo from '../components/seo'
import SliceList from '../components/sliceList'

export const query = graphql`
  query Page($id: String, $airport: String) {
    prismicPage(id: { eq: $id }) {
      ...PrismicPageFragment
    }
    allHolidayExtrasParking(sort: { name: ASC }, filter: { airport: { eq: $airport } }) {
      edges {
        node {
          address
          airport
          id
          latitude
          logo {
            url
          }
          longitude
          name
          meet_and_greet
          on_airport
          terminal
          transfer_time
          transfer_frequency
        }
      }
    }
    allHolidayExtrasHotels(sort: { name: ASC }, filter: { airport: { eq: $airport } }) {
      edges {
        node {
          address
          airport
          id
          latitude
          logo {
            url
          }
          longitude
          name
          star_rating
          on_airport
          distance_miles
        }
      }
    }
  }
`

const PageTemplate = ({ data }) => {
  const page = data.prismicPage
  const pageData = page.data
  const searchForm = pageData.search_form[0]
  let productData = data.allHolidayExtrasParking
  if (searchForm.search_form_default === 'Hotels and Parking' || searchForm.search_form_default === 'Hotels') {
    productData = data.allHolidayExtrasHotels
  }
  return (
    <Layout>
      {searchForm?.display_form ? (
        <>
          <div className='w-full py-3 md:py-6'>
            <SearchForm agentCode={searchForm.agent_code?.toUpperCase()} product={searchForm.search_form_default} location={searchForm.search_form_location} />
          </div>
          <h1 className='col-span-full row-span-full mx-auto flex w-full max-w-screen-xl items-center p-4 font-serif text-5xl leading-snug tracking-tight text-orange-500 lg:text-6xl'>
            {pageData.page_title}
          </h1>
        </>
      ) : (
        <h1 className='relative mx-auto my-5 max-w-screen-xl py-3 px-4 font-serif text-5xl leading-snug tracking-tight text-orange-500 lg:text-6xl'>{pageData.page_title}</h1>
      )}
      <SliceList slices={pageData.body} productData={productData} airport={searchForm.search_form_location} />
    </Layout>
  )
}

export default withPrismicPreview(PageTemplate)

export const Head = ({ data, location }) => {
  const pageData = data.prismicPage.data
  return (
    <>
      <html lang={data.prismicPage?.lang || 'en-gb'} />
      <Seo pathname={location.pathname} title={pageData.meta_title ? pageData.meta_title : pageData.title} description={pageData.meta_description} image={pageData.page_image?.url} />
    </>
  )
}
